import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Icon, LazyLoadImage } from 'ck-ui';
import { getImgixUrl } from 'ck-utils';
import styles from './ProductImage.module.scss';

const widths = [
  720,
  540,
  360,
];

class ProductImage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      imgLoaded: false,
    };
  }

  onImageLoad = () => {
    this.setState({ imgLoaded: true });
  };

  render() {
    const { image, title } = this.props;
    const { imgLoaded } = this.state;
    const srcSet = widths.map((width) => `${getImgixUrl(image, [
      'fit=crop',
      `w=${width}`,
      `h=${width / 0.8}`
    ])} ${width}w`).join(', ');
    const fallbackSrc = getImgixUrl(image);
    return (
      <figure className={styles.root}>
        {image ? (
          <>
            <LazyLoadImage
              width={720}
              height={900}
              className={styles.image}
              src={fallbackSrc}
              srcSet={srcSet}
              data-expand="-1"
              sizes={`(max-width: 767px) calc(50vw - 19px),
                      (max-width: 1087px) 35vw,
                      360px`}
              onLoad={this.onImageLoad}
              alt={title}
            />
            {!imgLoaded && <Icon className={styles.loading_icon} name="ck-logo" size="medium" />}
          </>
        ) : <Icon className={styles.loading_icon} name="ck-logo" size="medium" />}
      </figure>
    );
  }
}

ProductImage.propTypes = {
  image: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export { ProductImage };
